import { selectUserAccountsEnabled } from '@/app/state/app-state/app-state.selectors';
import { State } from '@state/model';
import { createSelector } from '@ngrx/store';


export const selectBTaxState = (state: State) => state.common.btax.state;
export const selectBTaxStateLoaded = createSelector(selectBTaxState, s => !!s);

export const selectBTaxAvailability = createSelector(selectBTaxState, s => s?.availability);
export const selectBTaxAccountDetailViewAvailability = createSelector(
    selectBTaxAvailability, a => a?.accountDetailView
);
export const selectBTaxWatchListsAvailability = createSelector(selectBTaxAvailability, a => a?.watchlists);

export const selectBTaxUpcomingYear = createSelector(selectBTaxState, s => s?.upcomingYear);
export const selectBTaxDisclaimer = createSelector(selectBTaxState, s => s?.disclaimer);

export const selectBTaxSubscriptionsEnabled = createSelector(selectBTaxAvailability, a => a?.subscriptions);

export const selectBTaxWatchListsEnabled = createSelector(
    selectUserAccountsEnabled, selectBTaxWatchListsAvailability,
    (accountsEnabled, watchListsAvailable) => accountsEnabled && watchListsAvailable
);

export const selectBTaxAutoDraftEnabled = createSelector(
    selectUserAccountsEnabled, selectBTaxAvailability,
    (accountsEnabled, availability) => accountsEnabled && availability?.autoDraft
);
export const selectBTaxInstallmentMonths = createSelector(selectBTaxState, s => s?.installmentMonths);

export const selectBTaxDisplayReceiptId = createSelector(selectBTaxState, s => s?.displayReceiptId);
export const selectBTaxDisplayPrintBillButton = createSelector(selectBTaxState, s => s?.displayPrintBillButton);

export const selectBTaxBlockMessages = createSelector(selectBTaxState, s => s?.blockMessages);
